import { useContext, useMemo } from "react"
import { AUTH_METHOD } from "@/shared/constants/authMethods"
import { AuthContext } from "../../context/auth/AuthProvider"
import type { TokenProvider } from "../auth/tokenProvider"
import { createCookieTokenProvider, createMsalTokenProvider } from "../auth/tokenProvider"
import { createAuthApi } from "./authApi"
import type { IAuthApi } from "./iAuthApi"

/**
 * Hook to access the CMT Auth API
 * Provides methods for user authentication and authorization
 */
export function useAuthApi(): IAuthApi {
  const auth = useContext(AuthContext)

  if (!auth) {
    throw new Error("useAuthApi must be used within AuthProvider")
  }

  const provider = useMemo<TokenProvider>(() => {
    if (auth.type === AUTH_METHOD.MSAL) {
      return createMsalTokenProvider({ acquireTokenSilent: auth.acquireTokenSilent }, auth.accounts[0], auth.scopes)
    }

    return createCookieTokenProvider()
  }, [auth])

  return useMemo(() => createAuthApi(provider), [provider])
}
